import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ projectModel, project, configuration }) =>
    present(
      repository
        .duplicateModelFromProject(project, projectModel)
        .then((projectModel) =>
          repository
            .updateProjectConfiguration(project, configuration)
            .then(() => ({ project, projectModel, configuration })),
        )
        .catch((e) =>
          Promise.reject({
            projectModel,
            project,
            configuration,
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
